import {faTag} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'

interface SpecialRateBadgeProps {
  label: string
  className?: string
}

const SpecialRateBadge: React.FC<SpecialRateBadgeProps> = ({
  className,
  label
}) => {
  return (
    <div
      className={clsx(
        'badge badge-outline badge-accent rounded-full text-xs',
        className
      )}
    >
      <FontAwesomeIcon icon={faTag} className="mr-1" title="Special rate" />
      <span>{label}</span>
    </div>
  )
}

export default SpecialRateBadge
